var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgBgRepeatImg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4053",
    "data-name": "Group 4053",
    transform: "translate(-174 -1896)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(174 1896)",
    fill: "#24397a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "date_range-24px_2_",
    "data-name": "date_range-24px (2)",
    transform: "translate(190 1912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M0,0H48V48H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M11,20h4v4H11ZM39,10V38a4.012,4.012,0,0,1-4,4H7a4,4,0,0,1-4-4l.02-28A3.982,3.982,0,0,1,7,6H9V2h4V6H29V2h4V6h2A4.012,4.012,0,0,1,39,10ZM7,14H35V10H7ZM35,38V18H7V38ZM27,24h4V20H27Zm-8,0h4V20H19Z",
    transform: "translate(3 2)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgRepeatImg2);
export default __webpack_public_path__ + "static/media/bg-repeat-img2.c7b9205994e021718237410fb925d761.svg";
export { ForwardRef as ReactComponent };